import { getStoredSession } from "../fetch/authStorage";

export const checkAuth = async (): Promise<boolean> => {
  const session = getStoredSession();
  if (!session) return false;

  return true;
};
